import {AxiosError} from 'axios';
import {useMutation, useQueryClient} from 'react-query';
import {toast} from 'react-toastify';
import {
  ErrorCode,
  getPersianErrorCode,
} from '../../../global/helpers/ErrorCodes/ErrorCode';
import {ErrorResponse} from '../patchDirectLoanRequest/usePatchDirectLoanRequest';

import {patchLoanRequest} from './patchLoanRequest';

interface UsePatchLoanRequestProps {
  onSuccess?: () => void;
  onError?: (error: AxiosError<ErrorResponse>) => void;
}

const usePatchLoanRequest = ({
  onSuccess,
  onError,
}: UsePatchLoanRequestProps = {}) => {
  const queryClient = useQueryClient();

  const {mutate, isLoading} = useMutation({
    mutationFn: (payload: IPatchLoanRequestPayload) =>
      patchLoanRequest(payload),

    onSuccess: async () => {
      await queryClient.refetchQueries('get-list-loan-request');

      onSuccess?.();
    },

    onError: (error: AxiosError<ErrorResponse>) => {
      onError?.(error);

      const status = error.response?.status;

      if (status === 400) {
        const errorCode = error.response?.data?.error_code;

        if (errorCode === ErrorCode.ACTIVE_VALIDATION_ERROR) {
          toast.success(getPersianErrorCode(errorCode));
          return;
        }

        if (errorCode) {
          toast.error(getPersianErrorCode(errorCode));
          return;
        }
      }
    },
  });

  return {mutate, isLoading};
};

export default usePatchLoanRequest;
